import { Box, Stack } from '@dtx-company/design-system/src'
import { LOCG_DESIGN_SECTIONS_SMALL_VARIANT } from '../../LoggedOutCodeGenerator.constants'
import { forwardRef } from 'react'

export const CodeDesign = forwardRef<HTMLDivElement[], { hideBackButton?: boolean }>(
  (_props, ref) => {
    return (
      <>
        <Stack gap={{ xs: 8, md: 6 }} sx={{ width: '100%' }}>
          {LOCG_DESIGN_SECTIONS_SMALL_VARIANT.map(({ id, Component }, i) => (
            <Box
              key={id}
              id={id}
              ref={(el: HTMLDivElement) => {
                if (ref && 'current' in ref) {
                  ref.current = ref.current || []
                  ref.current[i] = el
                }
              }}
              sx={theme => ({
                maxWidth: {
                  md: theme.spacing(136)
                }
              })}
            >
              <Component isSmallVariant={true} />
            </Box>
          ))}
        </Stack>
      </>
    )
  }
)

CodeDesign.displayName = 'CodeDesign'
